import { assignable } from "../assignable";
import { assign } from "../assign";
import { isSet } from "../typeMatchers";

/**
 * Assign members of second array to first
 */
export function assignArray(target: any[], source: any[] | Set<any>): void {
	if (isSet(source)) {
		source = Array.from(source);
	}
	Array.isArray(source) &&
		source.forEach((item, index) =>
			assignable(target[index]) && assignable(item)
				? assign(target[index], item)
				: (target[index] = item === undefined ? target[index] : item),
		);
}
